<template>
  <div v-if="user_profile" id="NavbarMenu">
    <b-navbar spaced shadow>
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <h1 class="title is-4">
            WEALTH NAVI
            <b-tag
              v-if="user_profile.role === 'ceo'"
              type="is-primary"
              style="font-size: 10px; line-height: 0"
            >
              <b>{{ user_profile.role.toUpperCase() }} </b>
            </b-tag>
            <b-tag
              v-else-if="user_profile.role === 'admin'"
              type="is-danger"
              style="font-size: 10px; line-height: 0"
            >
              <b>{{ user_profile.role.toUpperCase() }} </b>
            </b-tag>
            <b-tag
              v-else-if="user_profile.role === 'manager'"
              type="is-warning"
              style="font-size: 10px; line-height: 0"
            >
              <b>{{ user_profile.role.toUpperCase() }} </b>
            </b-tag>
            <b-tag
              v-else
              type="is-info"
              style="font-size: 10px; line-height: 0"
            >
              <b>{{ user_profile.role.toUpperCase() }} </b>
            </b-tag>
          </h1>
        </b-navbar-item>
      </template>
      <template slot="start">
        <b-navbar-item tag="router-link" :to="{ name: 'factsheet' }">
          <b-icon class="navbar-icon" icon="file-document" size="is-small" />
          Fact Sheets
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ name: 'balancesheet' }">
          <b-icon class="navbar-icon" icon="scale-balance" size="is-small" />
          Balance Sheet
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ name: 'retirementsheet' }">
          <b-icon class="navbar-icon" icon="pine-tree" size="is-small" />
          Retirement
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ name: 'templates' }">
          <b-icon class="navbar-icon" icon="shape-plus" size="is-small" />
          Templates
        </b-navbar-item>
        <b-navbar-item
          v-if="user_profile.role === 'admin' || user_profile.role === 'ceo'"
          tag="router-link"
          :to="{ name: 'client' }"
        >
          <b-icon class="navbar-icon" icon="account-star" size="is-small" />
          Clients
        </b-navbar-item>
        <b-navbar-item
          v-if="user_profile.role === 'admin' || user_profile.role === 'ceo'"
          tag="router-link"
          :to="{ name: 'user' }"
        >
          <b-icon class="navbar-icon" icon="account-tie" size="is-small" />
          Users
        </b-navbar-item>
        <b-navbar-item
          v-if="user_profile.role === 'admin' || user_profile.role === 'ceo'"
          tag="router-link"
          :to="{ name: 'business-unit' }"
        >
          <b-icon class="navbar-icon" icon="chess-rook" size="is-small" />
          Business Unit
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ name: 'setting' }">
          <b-icon class="navbar-icon" icon="cog" size="is-small" />
          Setting
        </b-navbar-item>
        <b-navbar-item @click.prevent="performLogout()">
          <b-icon class="navbar-icon" icon="logout" size="is-small" />
          Logout
        </b-navbar-item>
      </template>
    </b-navbar>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import TokenManager from "@/utils/TokenManager";

export default {
  name: "NavbarMenu",
  computed: mapState(["user_profile"]),
  methods: {
    ...mapMutations({
      removeUserProfile: "REMOVE_USER_PROFILE"
    }),
    performLogout: function() {
      this.removeUserProfile();
      TokenManager.clearUserToken();

      this.$router.push({ name: "login" });
    }
  }
};
</script>

<style>
#NavbarMenu {
  text-align: left;
}

.navbar-menu {
  padding: 0.5rem 1rem;
}

.navbar-icon {
  margin-right: 0.1rem !important;
}
</style>
